module.exports = __webpack_public_path__ + "static/img/live.b245b45a.png";